var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-overlay-portal-target"},[_c('PortalTarget',{ref:"portalTarget",class:[
			'c-overlay-portal-target__target z-50',
			{ 'c-overlay-portal-target__target--active': _vm.hasContent } ],attrs:{"id":("c-overlay-portal-target-" + _vm._uid),"multiple":"","name":_vm.name},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }